import { isEmpty, isNil, isUndefined, merge } from 'lodash-es';

import { BaseToolbarProps } from '../../core/types/toolbar.js';
import { defaultToolbar } from '../constants/defaults.js';
import {
  HistogramChartToolbarConfig,
  HistogramChartToolbarProps,
} from '../types/histogram-props.js';
import { HistogramToolbarSlotProps } from '../types/toolbar.js';

const isUndefinedOrIsEmpty = (value?: { enabled?: boolean }) => {
  return isUndefined(value) && isEmpty(value);
};

const returnNullOrNegate = (value?: boolean) =>
  isNil(value) ? undefined : !value;

/**
 * Builds a toolbar configuration based on context and slots
 * @param contextToolbar - toolbar context
 * @param slotToolbar - toolbar slots
 * @param slotDownloadCSV -
 * @param contextDownloadCSV -
 */
export function getToolbarConfiguration(
  contextToolbar: (HistogramChartToolbarProps & BaseToolbarProps) | undefined,
  slotToolbar: HistogramToolbarSlotProps | undefined,
  slotDownloadCSV?: { enabled?: boolean },
  contextDownloadCSV?: { enabled?: boolean },
): HistogramChartToolbarConfig {
  const hasNoDownloadCsvConfigured =
    isUndefinedOrIsEmpty(slotDownloadCSV) &&
    isUndefinedOrIsEmpty(contextDownloadCSV);
  if (!contextToolbar && isEmpty(slotToolbar) && hasNoDownloadCsvConfigured) {
    return { ...defaultToolbar };
  }

  return merge({}, defaultToolbar, contextToolbar, slotToolbar, {
    downloadData: slotDownloadCSV ?? contextDownloadCSV,
    enabled:
      returnNullOrNegate(slotToolbar?.hidden) ??
      returnNullOrNegate(contextToolbar?.hidden) ??
      contextToolbar?.enabled,
  });
}
